const buttonLogin = document.querySelector('#login-btn');
buttonLogin.addEventListener('click', function (e) {
  const errorMsgNode = $('.login-error-msg')

    const errorNames = {}

    errorMsgNode.removeClass('form__message-error form__message-success form__message-server')

    const formData = new URLSearchParams();
    $('#customer_login').serializeArray().forEach(item => {
      if (!item.value) {
        errorNames[item.name] = `${item.name} can't be blank.`
      }
      formData.append(item.name, item.value);
    })

    if (Object.keys(errorNames).length > 0) {
      const errorHtml = errorFormMessage(errorNames)
      errorMsgNode.find('.errors').html(errorHtml)
      errorMsgNode.addClass('form__message-error')
      return
    }

    $(e.target).attr('disabled', true)

    fetch('/a/account/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: formData
    })
    .then(response => response.json())
    .then(async (data) => {
      if (data.code === 0) {
        const parts = data.data.redirect_url.split('/')
        const token = parts[parts.length - 1]

        try {
          await window.ShopifyConstant.getMt_t(token, 'Login Failed')
          errorMsgNode.addClass('form__message-success')
          if (window.location.hostname == '127.0.0.1') {
            window.location.href = `http://127.0.0.1:9292/account/login/multipass/${token}`
            return
          }
          window.location.href = data.data.redirect_url
          return
        } catch (error) {
          data.msg = error
        }
      }

      let errorHtml = ''
      if (data.msg && typeof data.msg == 'object') {
        for (const key in data.msg) {
          errorHtml += `<li>${data.msg[key]}</li>`
        }
      } else {
        errorHtml += `<li>${data.msg}</li>`
      }

      errorMsgNode.find('.errors').html(errorHtml)
      errorMsgNode.addClass('form__message-error')

      $(e.target).attr('disabled', false)
    })
    .catch(error => {
      errorMsgNode.addClass('form__message-error form__message-server')
      $(e.target).attr('disabled', false)
    })
})

const recoverLogin = document.querySelector('#recover-btn');
recoverLogin.addEventListener('click', function (e) {
  const errorMsgNode = $('.recover-error-msg')

  $(e.target).attr('disabled', true)

  errorMsgNode.removeClass('form__message-error form__message-success form__message-server')

  const formData = new URLSearchParams();
  $('#recover_customer').serializeArray().forEach(item => {
    formData.append(item.name, item.value);
  })

  fetch('/a/account/recover', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: formData
  })
  .then(response => response.json())
  .then(data => {
    $(e.target).attr('disabled', false)

    let errorHtml = ''
    if (data.msg && typeof data.msg == 'object') {
      for (const key in data.msg) {
        errorHtml += `<li>${data.msg[key]}</li>`
      }
    } else {
      errorHtml += `<li>${data.msg}</li>`
    }

    errorMsgNode.find('.errors').html(errorHtml)
  
    if (data.code === 0) {
      errorMsgNode.addClass('form__message-success')
      return
    }

    errorMsgNode.addClass('form__message-error')
  })
  .catch(error => {
    errorMsgNode.addClass('form__message-error form__message-server')
    $(e.target).attr('disabled', false)
  });
},true);

function errorFormMessage (errorNames = {'email': '', 'password': ''}) {
  let errorHtml = ''
  for (const key in errorNames) {
    errorHtml += `<li>${errorNames[key]}</li>`
  }
  return errorHtml
}